var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.839,
    height: 68.983,
    viewBox: "0 0 68.839 68.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:rgba(255,255,255,.65)}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1417",
    "data-name": "Group 1417",
    transform: "translate(-1001.021 -462.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1162",
    d: "M1027.274 506.645a1.154 1.154 0 0 1-1.154-1.154v-23.922a1.153 1.153 0 0 1 1.154-1.154 1.154 1.154 0 0 1 1.154 1.154v23.922a1.154 1.154 0 0 1-1.154 1.154z",
    className: "prefix__cls-1",
    "data-name": "Path 1162",
    transform: "translate(32.811 23.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1163",
    d: "M1029.485 475.039c-3.039 0-5.055-3.862-5.055-6.417a5.055 5.055 0 1 1 10.108 0c0 2.554-2.017 6.417-5.053 6.417zm0-9.238a2.789 2.789 0 0 0-2.748 2.822c0 1.7 1.419 4.109 2.748 4.109s2.746-2.411 2.746-4.109a2.788 2.788 0 0 0-2.746-2.823z",
    className: "prefix__cls-1",
    "data-name": "Path 1163",
    transform: "translate(30.602 1.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1164",
    d: "M1035.078 521.556a1.154 1.154 0 0 1-1.151-1.091l-1.541-28.285v-14.049l-13.786-1.285a2.576 2.576 0 0 1-.192-5.1c2.54-.429 16.243-2.695 16.827-2.734a2.935 2.935 0 0 1 2.776 1.687 2.326 2.326 0 0 0 2.118 1.107 2.326 2.326 0 0 0 2.118-1.107 2.923 2.923 0 0 1 2.773-1.687l.773.037a11.213 11.213 0 0 1 2 .15 1.222 1.222 0 0 1 .432.231c.554.468 2.238 1.892 1.488 22.357a1.526 1.526 0 0 1-.455.958 1.876 1.876 0 0 1-1.44.348l-1.493 27.369a1.136 1.136 0 0 1-1.214 1.089 1.154 1.154 0 0 1-1.089-1.216l1.542-28.285a1.58 1.58 0 0 1 .461-.951 1.818 1.818 0 0 1 1.415-.358c.489-14.441-.314-18.354-.658-19.344-.3-.012-.715-.028-1.084-.044l-.824-.039c-.275-.03-.461.208-.57.425a4.576 4.576 0 0 1-4.176 2.374 4.572 4.572 0 0 1-4.176-2.374c-.109-.215-.282-.464-.57-.425-.649.069-12.438 2.005-16.589 2.706-.067.011-.205.034-.2.268s.152.249.214.256l14.833 1.384a1.153 1.153 0 0 1 1.047 1.149v15.034l1.539 28.222a1.154 1.154 0 0 1-1.089 1.216zm12.791-29.395z",
    className: "prefix__cls-1",
    "data-name": "Path 1164",
    transform: "translate(19.958 9.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1165",
    d: "M1045.964 514.964h-43.789a1.153 1.153 0 0 1-1.154-1.154v-48.673a1.154 1.154 0 0 1 1.154-1.154h46.1a1.154 1.154 0 1 1 0 2.307h-44.943v46.367h42.636a1.154 1.154 0 1 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1165",
    transform: "translate(0 2.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1166",
    d: "M1017.172 498.346a1.154 1.154 0 0 1-1.154-1.154v-8.906a1.154 1.154 0 0 1 2.307 0v8.906a1.154 1.154 0 0 1-1.153 1.154z",
    className: "prefix__cls-1",
    "data-name": "Path 1166",
    transform: "translate(19.605 32.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1167",
    d: "M1029.15 493.3h-16a1.154 1.154 0 1 1 0-2.307h16a1.154 1.154 0 0 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1167",
    transform: "translate(14.353 37.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1168",
    d: "M1013.154 468.758A1.154 1.154 0 0 1 1012 467.6v-4.356a1.154 1.154 0 0 1 2.307 0v4.356a1.154 1.154 0 0 1-1.153 1.158z",
    className: "prefix__cls-1",
    "data-name": "Path 1168",
    transform: "translate(14.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1169",
    d: "M1021.154 468.758A1.154 1.154 0 0 1 1020 467.6v-4.356a1.154 1.154 0 1 1 2.307 0v4.356a1.154 1.154 0 0 1-1.153 1.158z",
    className: "prefix__cls-1",
    "data-name": "Path 1169",
    transform: "translate(24.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1170",
    d: "M1017.69 480.844h-11.536a1.154 1.154 0 0 1-1.154-1.154v-11.536a1.154 1.154 0 0 1 1.154-1.154h11.536a1.154 1.154 0 0 1 1.154 1.154v11.536a1.154 1.154 0 0 1-1.154 1.154zm-10.383-2.307h9.229v-9.229h-9.229z",
    className: "prefix__cls-1",
    "data-name": "Path 1170",
    transform: "translate(5.202 6.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1171",
    d: "M1028.032 470.307h-13.844a1.154 1.154 0 1 1 0-2.307h13.844a1.154 1.154 0 1 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1171",
    transform: "translate(15.705 7.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1172",
    d: "M1016.332 472.307h-2.144a1.154 1.154 0 1 1 0-2.307h2.144a1.154 1.154 0 0 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1172",
    transform: "translate(15.705 10.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1173",
    d: "M1017.69 489.844h-11.536a1.154 1.154 0 0 1-1.154-1.154v-11.536a1.154 1.154 0 0 1 1.154-1.154h11.536a1.154 1.154 0 0 1 1.154 1.154v11.536a1.154 1.154 0 0 1-1.154 1.154zm-10.383-2.307h9.229v-9.229h-9.229z",
    className: "prefix__cls-1",
    "data-name": "Path 1173",
    transform: "translate(5.202 18.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1174",
    d: "M1028.032 479.307h-13.844a1.154 1.154 0 1 1 0-2.307h13.844a1.154 1.154 0 1 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1174",
    transform: "translate(15.705 19.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1175",
    d: "M1021.11 481.307h-6.922a1.154 1.154 0 1 1 0-2.307h6.922a1.154 1.154 0 0 1 0 2.307z",
    className: "prefix__cls-1",
    "data-name": "Path 1175",
    transform: "translate(15.705 22.099)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultClassroom);
export default __webpack_public_path__ + "static/media/default-classroom.5961f98c1a39d915e11ad0981ef081ba.svg";
export { ForwardRef as ReactComponent };